<template>
  <header>
    <div
      @click="resetSettings()"
      :class="style.logo"
      :style="{
        backgroundImage: `url(${getMiniPhoto(
          getClinic.logo,
          'logoWidget.svg'
        )})`
      }"
    />
    <div :class="style.info">
      <h3 v-text="getClinic.clinic" />
      <div v-for="address in getAddressList">
        <div :class="style.addressCheck">
          <input :id="address + 'widget'" checked="true" type="checkbox" />
          <label v-if="getAddressList.length > 1" :for="address + 'widget'" />
          <span v-else />
          <p v-text="address" />
        </div>
      </div>
    </div>
  </header>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {getMiniPhoto} from "../ScriptsWidget";
import {defineComponent} from "vue";
export default defineComponent({
  name: "HeaderWidget",
  data() {
    return {
      style,
      DOMAIN: "readds.ru",
      getMiniPhoto
    };
  },
  async mounted() {
    this.DOMAIN = import.meta.env.VITE_DOMAIN;
  },
  methods: {
    resetSettings() {
      this.$widgetStore.reset();
    }
  },
  computed: {
    getClinic() {
      return this.$widgetStore.clinic;
    },
    getAddressList() {
      return this.getClinic.addressList || [];
    }
  }
});
</script>
